module.exports = __webpack_public_path__ + "img/ИФ-1(А)-050.e18f05a2.png";